import React from 'react';
import { Link } from 'react-router-dom';


const List = () => {
	return (
<>
<p><Link to="/">Home</Link></p>
<h1>List of mythologies</h1>
<p>Myth is a folklore genre consisting of narratives that play a fundamental role in a society, such as foundational tales or origin myths. The main characters in myths are usually non-humans, such as gods, demigods, and other supernatural figures. However, others also include humans, animals, or combinations in their classificiation of myth. Stories of everyday human beings, although often of leaders of some type, are usually contained in legends, as opposed to myths. Myths are sometimes distinguished from legends in that myths deal with gods, usually have no historical basis, and are set in a world of the remote past, very different from that of the present.</p>
<p>The term mythology may either refer to the study of myths in general, or a body of myths regarding a particular subject. The compilation or description of myths is sometimes known as mythography, a term which can also be used of a scholarly anthology of myths.</p>

<ul>
<p style={{"font-weight":"bold","margin-bottom":"0"}}>Mythologies</p>
<p style={{"font-weight":"bold","margin-top":"0"}}>by people, location, religion, worldwide (not comprehensive):</p>
<li><a href="https://en.wikipedia.org/wiki/Ainu_people#Religion">Ainu</a></li>
<li><a href="https://en.wikipedia.org/wiki/Religion_in_pre-Islamic_Arabia">Arabian</a></li>
<li><a href="https://en.wikipedia.org/wiki/Armenian_mythology">Armenian</a></li>
<li><a href="https://en.wikipedia.org/wiki/Aztec_mythology">Aztec</a></li>
<li><a href="https://en.wikipedia.org/wiki/Baltic_mythology">Baltic</a></li>
<li><a href="https://en.wikipedia.org/wiki/Basque_mythology">Basque</a></li>
<li><a href="https://en.wikipedia.org/wiki/Brazilian_mythology">Brazilian</a></li>
<li><a href="https://en.wikipedia.org/wiki/Buddhist_myths">Buddhist</a></li>
<li><a href="https://en.wikipedia.org/wiki/Ancient_Canaanite_religion">Canaanite</a></li>
<li><a href="https://en.wikipedia.org/wiki/Chinese_mythology">Chinese</a></li>
<li><a href="https://en.wikipedia.org/wiki/Choctaw_mythology">Choctaw</a></li>
<li><a href="https://en.wikipedia.org/wiki/Christian_mythology">Christian</a></li>
<li><a href="https://en.wikipedia.org/wiki/Egyptian_mythology">Egyptian</a></li>
<li><a href="https://en.wikipedia.org/wiki/English_mythology">English</a></li>
<li><a href="https://en.wikipedia.org/wiki/Philippine_mythology">Filipino</a></li>
<li><a href="https://en.wikipedia.org/wiki/Finnish_mythology">Finnish</a></li>
<li><a href="https://en.wikipedia.org/wiki/Germanic_mythology">Germanic</a></li>
<li><a href="https://en.wikipedia.org/wiki/Greek_mythology">Greek</a></li>
<li><a href="https://en.wikipedia.org/wiki/Haida_mythology">Haida</a></li>
<li><a href="https://en.wikipedia.org/wiki/Hindu_mythology">Hindu</a></li>
<li><a href="https://en.wikipedia.org/wiki/Hittite_mythology_and_religion">Hittite</a></li>
<li><a href="https://en.wikipedia.org/wiki/Hungarian_mythology">Hungarian</a></li>
<li><a href="https://en.wikipedia.org/wiki/Inca_mythology">Incan</a></li>
<li><a href="https://en.wikipedia.org/wiki/Inuit_religion">Inuit</a></li>
<li><a href="https://en.wikipedia.org/wiki/Islamic_mythology">Islamic</a></li>
<li><a href="https://en.wikipedia.org/wiki/Japanese_mythology">Japanese</a></li>
<li><a href="https://en.wikipedia.org/wiki/Jewish_mythology">Jewish</a></li>
<li><a href="https://en.wikipedia.org/wiki/List_of_Lithuanian_gods_and_mythological_figures">Lithuanian</a></li>
<li><a href="https://en.wikipedia.org/wiki/Lugbara_mythology">Lugbara</a></li>
<li><a href="https://en.wikipedia.org/wiki/Lusitanian_mythology">Lusitanian</a></li>
<li><a href="https://en.wikipedia.org/wiki/Māori_mythology">Māori</a></li>
<li><a href="https://en.wikipedia.org/wiki/Maya_mythology">Mayan</a></li>
<li><a href="https://en.wikipedia.org/wiki/Mesopotamian_myths">Mesopotamian</a></li>
<li><a href="https://en.wikipedia.org/wiki/Micronesian_mythology">Micronesian</a></li>
<li><a href="https://en.wikipedia.org/wiki/Muisca_religion">Muisca</a></li>
<li><a href="https://en.wikipedia.org/wiki/Ohlone_mythology">Ohlone</a></li>
<li><a href="https://en.wikipedia.org/wiki/Persian_mythology">Persian</a></li>
<li><a href="https://en.wikipedia.org/wiki/Roman_mythology">Roman</a></li>
<li><a href="https://en.wikipedia.org/wiki/Sami_mythology">Sami</a></li>
<li><a href="https://en.wikipedia.org/wiki/Scythian_religion">Scythian</a></li>
<li><a href="https://en.wikipedia.org/wiki/Slavic_religion">Slavic</a></li>
<li><a href="https://en.wikipedia.org/wiki/Turkic_mythology">Turkic</a></li>
<li><a href="https://en.wikipedia.org/wiki/Zunbils">Zunbil</a></li>
</ul>

<hr/>

<ul>
<p style={{"font-weight":"bold"}}>Myths by type</p>
<li><a href="https://en.wikipedia.org/wiki/Creation_myth">Creation myth</a></li>
</ul>

<hr/>

<ul>
<p style={{"font-weight":"bold"}}>Gods by type</p>

<li><a href="https://en.wikipedia.org/wiki/Category:Agricultural_deities">Agricultural deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/List_of_art_deities">Art deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/List_of_beauty_deities">Beauty deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/Category:Childhood_deities">Childhood deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/Category:Creator_deities">Creator deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/Chthonic">Chthonic deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/List_of_death_deities">Death deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/List_of_earth_deities">Earth deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/List_of_earth_deities">Earth deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/List_of_fire_gods">Fire deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/List_of_knowledge_deities">Knowledge deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/Category:Liminal_deities">Liminal deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/List_of_lunar_deities">Lunar deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/Category:Messenger_gods">Messenger deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/Category:Mountain_deities">Mountain deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/Category:Music_and_singing_deities">Music and singing deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/Category:Nature_deities">Nature deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/List_of_night_deities">Night deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/List_of_solar_deities">Solar deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/Category:Time_and_fate_deities">Time and fate deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/Category:Trickster_deities">Trickster deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/Category:Underworld_deities">Underworld deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/Vegetation_deity#List_of_vegetation_deities">Vegetation deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/List_of_water_deities">Water deities</a></li>
<li><a href="https://en.wikipedia.org/wiki/Category:War_deities">War deities</a></li>


</ul>


</>
)
}

export default List;